const normalizeAddressText = (value) => String(value || '').replace(/\s+/g, ' ').trim();

const stripPhilippineAddressLabel = (value) => normalizeAddressText(value)
  .replace(/\b\d{4}\b/g, '')
  .replace(/^(province of|province|prov\.?)\s+/i, '')
  .replace(/^(city of|city|municipality of|municipality|mun\.?)\s+/i, '')
  .replace(/^(barangay|brgy\.?)\s+/i, '')
  .replace(/\s+(province|city|municipality)$/i, '')
  .trim();

export const splitPhilippineAddress = (fullAddress) => {
  const chunks = String(fullAddress || '')
    .split(/[\n,;|]+/)
    .map((chunk) => normalizeAddressText(chunk).replace(/\b\d{4}\b/g, '').trim())
    .filter(Boolean);

  const result = {
    provinceName: '',
    cityName: '',
    districtName: '',
    addressDetail: ''
  };

  if (chunks.length === 0) return result;

  const usedIndexes = new Set();
  let provinceIndex = chunks.findIndex((chunk) => /^(province of|province|prov\.?)\s+/i.test(chunk));
  if (provinceIndex < 0) provinceIndex = chunks.length - 1;
  result.provinceName = stripPhilippineAddressLabel(chunks[provinceIndex]);
  usedIndexes.add(provinceIndex);

  let cityIndex = chunks.findIndex((chunk, index) => (
    !usedIndexes.has(index)
    && (/^(city of|city|municipality of|municipality|mun\.?)\s+/i.test(chunk)
      || /\s+(city|municipality)$/i.test(chunk))
  ));
  if (cityIndex < 0 && provinceIndex > 0) cityIndex = provinceIndex - 1;
  if (cityIndex >= 0 && !usedIndexes.has(cityIndex)) {
    result.cityName = stripPhilippineAddressLabel(chunks[cityIndex]);
    usedIndexes.add(cityIndex);
  }

  let barangayIndex = chunks.findIndex((chunk, index) => (
    !usedIndexes.has(index) && /^(barangay|brgy\.?)\s+/i.test(chunk)
  ));
  if (barangayIndex < 0 && cityIndex > 0) barangayIndex = cityIndex - 1;
  if (barangayIndex >= 0 && !usedIndexes.has(barangayIndex)) {
    result.districtName = stripPhilippineAddressLabel(chunks[barangayIndex]);
    usedIndexes.add(barangayIndex);
  }

  result.addressDetail = chunks
    .filter((_, index) => !usedIndexes.has(index))
    .join(', ');

  return result;
};
